<div class="alert-sidebar-item" [ngClass]="{ 'selected': alert.isSelected }">
    <div class="severity {{alert.severity}}"></div>
    <div class="alert-item-content">
        <app-alert-item [alert]="alert"
                        (detailsClick)="onDetailsClick()"
                        (investigateClick)="onInvestigateClick()"></app-alert-item>
    </div>
</div>
